import apiClient from './apiClient';

/**
 * Event Participants API functions
 */
export const eventParticipantsApi = {
  /**
   * Get event participants data
   */
  getEventParticipants: async (eventId: string) => {
    try {
      console.log('Fetching event participants from API...');
      const response = await apiClient.get(`/api/v2/web/events/${eventId}/participants`);
      console.log('Event participants API response data:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error in getEventParticipants:', error);
      throw error;
    }
  },

  /**
   * Save user selection for event
   */
  saveUserSelection: async (eventId: string, selectedUserIds: string[]) => {
    try {
      console.log('Saving user selection...');
      
      // Get user ID from session/context - this should be dynamically determined
      // For now, we'll need to get this from the current user context
      const userResponse = await apiClient.get('/api/v2/web/auth/me');
      const userId = userResponse.data.User_ID;

      // Use the selections endpoint as in the original Django implementation
      const response = await apiClient.post(
        `/api/v2/web/events/${eventId}/selections/user/${userId}`, 
        { selected_user_ids: selectedUserIds }
      );
      
      console.log('Save selection API response data:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error in saveUserSelection:', error);
      throw error;
    }
  }
};
